import { SenderProperty } from "./message.model";

export class ConversationEventModel{
    _id?: any;
    uuid: string;
    revision: string;
    status: string;
    vrsn: string;
    conversation_type: string;
    channel: string;
    conversation_uuid: string;
    session_uuid: string;
    event_date: Date;
    create_date: Date;
    update_date: Date;
    source: string;
    sender_property: SenderProperty;
    event_type: string;
    event_request;
    event_description: string;
    event_status: string;
}